import { FC } from 'react';
import { IContentItem } from '@kontent-ai/delivery-sdk';
import { RenderOn } from '../../RenderOn/RenderOn';
import {
  AsyncComponent,
  ConfiguredComponents,
} from '@r-and-a-shared-ui/core-component-config';

import styles from './PlayerPortalsGridPageColumn.module.scss';

type PlayerPortalsGridPageColumnProps = {
  content?: IContentItem<any>[];
};

export const PlayerPortalsGridPageColumn: FC<
  PlayerPortalsGridPageColumnProps
> = ({ content }) => {
  const hasContent = Array.isArray(content) && content.length > 0;
  return (
    <div className={styles['grid-column']}>
      <div
        data-testid={'page-column-content'}
        className={styles['grid-column--content']}
      >
        <RenderOn condition={hasContent}>
          {content?.map((x: IContentItem<any>) => {
            return (
              <AsyncComponent
                kontentItem={x}
                contentType={x.system.type as ConfiguredComponents}
                key={x.system.id}
              />
            );
          })}
        </RenderOn>
      </div>
    </div>
  );
};
